export default "__VITE_ASSET__a9e40e53__"